export const translations = {
  en: {
    // Header
    about: "About",
    programs: "Programs",
    projects: "Projects",
    contact: "Contact",
    getInvolved: "Get Involved",
    home: "Home",
    mediaCenter: "Media Center",
    
    // Hero Section
    heroTitle: "Mandola Relief & Reconstruction Organization",
    heroSubtitle: "Supporting vulnerable communities across Sudan",
    heroDescription: "MRRO is a national humanitarian organization dedicated to supporting crisis-affected communities, internally displaced persons, and vulnerable populations across Sudan through integrated humanitarian and development programs.",
    learnAboutWork: "Learn About Our Work",
    ourPrograms: "Our Programs",
    contactUs: "Contact Us",
    
    // About Section
    aboutTitle: "About MRRO",
    aboutP1: "Mandola Relief & Reconstruction Organization (MRRO) is a national humanitarian and development organization committed to supporting vulnerable communities affected by crises, displacement, and poverty across Sudan.",
    aboutP2: "The organization provides life-saving humanitarian assistance, supports recovery efforts, and promotes sustainable development through integrated programs designed to respond to both urgent needs and long-term community challenges.",
    ourFocus: "Our Focus",
    essentialServices: "Essential Services",
    idps: "Internally Displaced Persons (IDPs)",
    vulnerableCommunities: "Vulnerable host communities",
    crisisAffected: "Crisis-affected populations",
    healthcare: "Healthcare access",
    safeWater: "Safe water provision",
    sanitation: "Sanitation infrastructure",
    livelihood: "Livelihood support",
    aboutP3: "MRRO is guided by the core humanitarian principles of humanity, neutrality, impartiality, and independence, while ensuring transparency, accountability, and strong community engagement across all its programs.",
    
    // Vision & Mission
    vision: "Vision",
    visionText: "A resilient and self-reliant society across Sudan where vulnerable communities have equitable access to essential services, protection, and sustainable livelihood opportunities.",
    mission: "Mission",
    missionText: "To provide effective humanitarian assistance and development support to vulnerable communities across Sudan through inclusive, accountable, and community-centered programs that strengthen resilience and promote sustainable recovery.",
    
    // Values
    coreValues: "Core Values",
    valuesIntro: "MRRO's work is guided by a set of fundamental humanitarian values:",
    humanity: "Humanity",
    humanityDesc: "Promoting dignity and respect for all individuals.",
    neutralityImpartiality: "Neutrality and Impartiality",
    neutralityDesc: "Providing assistance based solely on need without discrimination.",
    accountability: "Accountability and Transparency",
    accountabilityDesc: "Ensuring responsible and transparent use of resources.",
    integrity: "Integrity and Professionalism",
    integrityDesc: "Maintaining the highest ethical and professional standards.",
    participation: "Community Participation and Inclusiveness",
    participationDesc: "Empowering communities to participate in decisions that affect their lives.",
    
    // Objectives
    strategicObjectives: "Strategic Objectives",
    objectivesIntro: "MRRO works to achieve its mission through the following strategic objectives:",
    objective1: "Deliver timely humanitarian assistance to crisis-affected populations across Sudan.",
    objective2: "Improve access to essential services including health, water, sanitation, and hygiene.",
    objective3: "Strengthen resilience and recovery among displaced and vulnerable communities.",
    objective4: "Promote public health awareness and disease prevention.",
    objective5: "Support community-led development and local capacity building.",
    
    // Coverage
    geographicCoverage: "Geographic Coverage",
    coverageIntro: "MRRO operates at the national level and implements humanitarian and development programs across multiple regions of Sudan based on emerging needs and humanitarian priorities.",
    currentOperations: "Current Operations",
    coverageText: "The organization has experience working in several areas and maintains operational flexibility that allows rapid response to emergencies and expansion to other regions across Sudan when required.",
    redSeaState: "Red Sea State",
    khartoumState: "Khartoum State",
    northDarfurState: "North Darfur State",
    gedarefState: "Gedaref State",
    blueNileState: "Blue Nile State",
    whiteNileState: "White Nile State",
    sennarState: "Sennar State",
    nationalReach: "National Reach",
    nationalReachDesc: "MRRO maintains operational flexibility to rapidly respond to emergencies and expand interventions to other regions across Sudan when required.",
    activeStates: "Active States",
    nationalCoverage: "National Coverage",
    
    // Programs
    programmaticAreas: "Programmatic Areas",
    programsIntro: "MRRO implements programs across several humanitarian and development sectors:",
    health: "Health",
    healthDesc: "Supporting access to healthcare services and strengthening health systems.",
    nutrition: "Nutrition",
    nutritionDesc: "Improving nutrition for vulnerable groups, especially women and children.",
    protection: "Protection",
    protectionDesc: "Ensuring safety, dignity, and protection for vulnerable populations.",
    education: "Education",
    educationDesc: "Supporting access to education for children and displaced communities.",
    wash: "Water, Sanitation and Hygiene (WASH)",
    washDesc: "Providing safe water, sanitation infrastructure, and hygiene awareness.",
    emergencyRelief: "Emergency Relief Assistance",
    emergencyReliefDesc: "Delivering life-saving support during emergencies and crises.",
    foodSecurity: "Food Security & Livelihood Support",
    foodSecurityDesc: "Helping communities improve food access and sustainable income.",
    communityDevelopment: "Community Development",
    communityDevelopmentDesc: "Supporting long-term community resilience and development initiatives.",
    operationalApproach: "Operational Approach",
    approachText: "MRRO adopts a community-centered and participatory approach in the design and implementation of its programs. Interventions are based on field assessments and implemented in close coordination with local communities, government authorities, and humanitarian partners.",
    communityEngagement: "Community Engagement",
    communityEngagementDesc: "Working closely with community leaders and local groups",
    mealSystems: "MEAL Systems",
    mealSystemsDesc: "Monitoring, Evaluation, Accountability, and Learning integration",
    qualityDelivery: "Quality Delivery",
    qualityDeliveryDesc: "Ensuring transparency, accountability, and continuous improvement",
    
    // Projects
    projectsFieldExperience: "Projects & Field Experience",
    projectsIntro: "Highlighting our recent humanitarian interventions and their impact on communities",
    washProject: "WASH Support for Abu Bakr Al-Siddiq IDP Shelter Center",
    washLocation: "Red Sea State, Sudan",
    washTarget: "Abu Bakr Al-Siddiq IDP Shelter Center",
    washDescription: "MRRO implemented a Water, Sanitation, and Hygiene (WASH) project to improve sanitation conditions and promote public health among internally displaced persons residing in the shelter center.",
    keyActivities: "Key Activities",
    washActivity1: "Provision of safe drinking water for residents",
    washActivity2: "Distribution of hygiene and cleaning materials",
    washActivity3: "Environmental sanitation campaigns around the shelter center",
    washActivity4: "Emptying and cleaning latrines at the shelter health facility",
    washActivity5: "Hygiene and health awareness sessions for displaced families",
    impact: "Impact",
    washImpact: "The project helped improve sanitation conditions, reduce health risks, and increase hygiene awareness among displaced communities.",
    emergencyWaterProject: "Emergency Water Response – Taweela, North Darfur",
    emergencyLocation: "Taweela Area, North Darfur State",
    emergencyTarget: "Deba Naira IDP Camp",
    emergencyDescription: "MRRO implemented an emergency humanitarian intervention to provide safe drinking water to internally displaced populations living in Deba Naira Camp.",
    emergencyActivity1: "Emergency water provision to IDP camp",
    emergencyActivity2: "Water system maintenance and repair",
    emergencyActivity3: "Community mobilization for water management",
    emergencyActivity4: "Health and hygiene education sessions",
    emergencyImpact: "The intervention addressed urgent water shortages and helped improve living conditions by ensuring access to safe drinking water and reducing water-related health risks.",
    eidJoyProject: "Eid Joy Initiative",
    eidJoyLocation: "Khartoum, Khartoum State",
    eidJoyTarget: "Displaced children and families",
    eidJoyDescription: "MRRO organized a special Eid celebration initiative to bring joy and support to displaced children and families during Eid al-Fitr, providing essential items and creating moments of happiness during difficult times.",
    eidJoyActivity1: "Distribution of Eid gifts and clothing to displaced children",
    eidJoyActivity2: "Provision of food packages and essential supplies to families",
    eidJoyActivity3: "Organization of recreational activities and celebrations",
    eidJoyActivity4: "Community gathering and social support activities",
    eidJoyImpact: "The initiative brought joy to displaced children and families, strengthened community bonds, and provided essential support during the Eid celebration, helping restore a sense of normalcy and dignity.",
    govInvolvement: "Government Collaboration",
    partnershipsCollaboration: "Partnerships & Institutional Collaboration",
    partnershipsText: "MRRO collaborates with humanitarian organizations, civil society institutions, and government authorities to ensure effective coordination and delivery of services.",
    governmentPartners: "Government Partners",
    federalMinistryHealth: "Federal Ministry of Health – Sudan",
    stateMinistryHealthPort: "State Ministry of Health – Port Sudan (Red Sea State)",
    stateMinistryHealthKhartoum: "State Ministry of Health – Khartoum State",
    stateMinistryHealthDarfur: "State Ministry of Health – North Darfur State",
    collaborationFocus: "Collaboration Focus",
    facilitateOperations: "Facilitate humanitarian operations",
    supportHealthPrograms: "Support public health programs",
    strengthenResponse: "Strengthen emergency response coordination",
    enhanceParticipation: "Enhance community participation",
    targetArea: "Target Area",
    
    // Partners
    partnersTitle: "Our Partners",
    partnersIntro: "MRRO collaborates with humanitarian organizations, civil society institutions, and government authorities to ensure effective coordination and delivery of services.",
    internationalPartners: "International Partners",
    nationalPartners: "National Partners",
    
    // Target Groups
    targetGroupsTitle: "Our Target Groups",
    targetGroupsIntro: "MRRO focuses on supporting the most vulnerable populations across Sudan",
    vulnerableYouth: "Vulnerable male and female youth",
    vulnerableWomen: "Vulnerable women and men",
    vulnerableChildren: "Vulnerable children",
    personsWithDisabilities: "Persons with Disabilities",
    targetGroupsNote: "These categories include IDPs, refugees, returnees, and host communities.",
    
    // Organizational Structure
    orgStructureTitle: "Organizational Structure",
    boardOfDirectors: "Board of Directors",
    executiveDirector: "Executive Director",
    programCoordinator: "Program Coordinator",
    adminFinanceHR: "Admin, Finance & HR",
    programOfficer: "Program Officer",
    mealOfficer: "MEAL Officer",
    fieldCoordinator: "Field Coordinator",
    
    // Team
    teamTitle: "Our Team",
    teamIntro: "Meet the dedicated professionals leading MRRO's humanitarian efforts",
    executiveDirectorName: "Executive Director",
    programAdvisor: "Program Advisor",
    publicRelations: "Public Relations",
    
    // Donation
    donationTitle: "Support Our Mission",
    donationIntro: "Your donation helps us continue our work promoting humanitarian assistance, supporting vulnerable communities, and building a better future for Sudan.",
    donateUSD: "Donate in USD",
    donateSDG: "Donate in SDG",
    usdDonationDesc: "International donations via bank transfer",
    sdgDonationDesc: "Local donations in Sudanese Pounds",
    bankName: "Bank Name",
    accountName: "Account Name",
    accountNumber: "Account Number",
    swiftCode: "SWIFT Code",
    branch: "Branch",
    contactForTransfer: "Contact for Transfer Details",
    mashreqBank: "Al Nile Al Mashreq Bank",
    mandolaOrg: "Mandola Organization",
    khartoumBank: "Khartoum Bank",
    altayebSiddiq: "Altayeb Siddiq",
    bankAccount2450180: "2450180",
    
    // Contact
    contactTitle: "Contact Us",
    contactIntro: "Get in touch with MRRO to learn more about our work or explore partnership opportunities",
    
    // Get Involved
    getInvolvedTitle: "Get Involved",
    getInvolvedSubtitle: "Support our mission through donations, volunteering, or partnerships",
    
    // Media Center
    mediaCenterTitle: "Media Center",
    mediaCenterSubtitle: "Explore our projects and humanitarian work through photos and videos",
    organization: "Organization",
    organizationName: "Mandola Relief & Reconstruction Organization (MRRO)",
    organizationType: "Humanitarian & Development Organization – Sudan",
    address: "Address",
    sudan: "Sudan",
    email: "Email",
    phone: "Phone",
    website: "Website",
    ourCommitment: "Our Commitment",
    commitmentP1: "MRRO remains committed to delivering high-quality humanitarian and development programs that effectively address the needs of vulnerable communities across Sudan.",
    commitmentP2: "Through strong partnerships with government institutions, humanitarian agencies, and community-based organizations, MRRO aims to expand its impact and contribute to sustainable recovery and development across the country.",
    strongPartnerships: "Strong Partnerships",
    effectivePrograms: "Effective Programs",
    sustainableImpact: "Sustainable Impact",
    
    // Footer
    footerDescription: "Supporting vulnerable communities across Sudan through humanitarian assistance, recovery programs, and sustainable development.",
    quickLinks: "Quick Links",
    aboutUs: "About Us",
    ourValues: "Our Values",
    contactInfo: "Contact Info",
    copyright: "2026 Mandola Relief & Reconstruction Organization (MRRO). All rights reserved.",
    backToTop: "Back to Top",
    language: "Language",
    english: "English",
    arabic: "العربية"
  },
  
  ar: {
    // Header
    about: "حول المنظمة",
    programs: "البرامج",
    projects: "المشاريع",
    contact: "اتصل بنا",
    getInvolved: "شارك معنا",
    home: "الرئيسية",
    mediaCenter: "المركز الإعلامي",
    
    // Hero Section
    heroTitle: "منظمة مندولا للإغاثة والإعمار",
    heroSubtitle: "دعم المجتمعات الضعيفة في جميع أنحاء السودان",
    heroDescription: "منظمة مندولا للإغاثة والإعمار هي منظمة إنسانية وطنية مكرسة لدعم المجتمعات المتضررة من الأزمات والنازحين داخلياً والفئات الضعيفة في جميع أنحاء السودان من خلال برامج إنسانية وتنموية متكاملة.",
    learnAboutWork: "تعرف على عملنا",
    ourPrograms: "برامجنا",
    contactUs: "اتصل بنا",
    
    // About Section
    aboutTitle: "حول منظمة مندولا للإغاثة والإعمار",
    aboutP1: "منظمة مندولا للإغاثة والإعمار هي منظمة إنسانية وتنموية وطنية ملتزمة بدعم المجتمعات الضعيفة المتضررة من الأزمات والنزوح والفقر في جميع أنحاء السودان.",
    aboutP2: "تقدم المنظمة المساعدات الإنسانية المنقذة للحياة، وتدعم جهود التعافي، وتعزز التنمية المستدامة من خلال برامج متكاملة مصممة للاستجابة للاحتياجات العاجلة والتحديات المجتمعية طويلة المدى.",
    ourFocus: "تركيزنا",
    essentialServices: "الخدمات الأساسية",
    idps: "النازحون داخلياً",
    vulnerableCommunities: "المجتمعات المضيفة الضعيفة",
    crisisAffected: "السكان المتضررون من الأزمات",
    healthcare: "الوصول للرعاية الصحية",
    safeWater: "توفير المياه الآمنة",
    sanitation: "البنية التحتية للصرف الصحي",
    livelihood: "دعم سبل العيش",
    aboutP3: "تسترشد منظمة مندولا بالمبادئ الإنسانية الأساسية للإنسانية والحياد وعدم التحيز والاستقلالية، مع ضمان الشفافية والمساءلة والمشاركة المجتمعية القوية في جميع برامجها.",
    
    // Vision & Mission
    vision: "الرؤية",
    visionText: "مجتمع مرن ومعتمد على الذات في جميع أنحاء السودان حيث تتمتع المجتمعات الضعيفة بوصول عادل للخدمات الأساسية والحماية وفرص العيش المستدامة.",
    mission: "الرسالة",
    missionText: "تقديم المساعدة الإنسانية الفعالة والدعم التنموي للمجتمعات الضعيفة في جميع أنحاء السودان من خلال برامج شاملة وخاضعة للمساءلة ومتمركزة حول المجتمع تعزز المرونة وتعزز التعافي المستدام.",
    
    // Values
    coreValues: "القيم الأساسية",
    valuesIntro: "يسترشد عمل منظمة مندولا بمجموعة من القيم الإنسانية الأساسية:",
    humanity: "الإنسانية",
    humanityDesc: "تعزيز الكرامة والاحترام لجميع الأفراد.",
    neutralityImpartiality: "الحياد وعدم التحيز",
    neutralityDesc: "تقديم المساعدة بناءً على الحاجة فقط دون تمييز.",
    accountability: "المساءلة والشفافية",
    accountabilityDesc: "ضمان الاستخدام المسؤول والشفاف للموارد.",
    integrity: "النزاهة والمهنية",
    integrityDesc: "الحفاظ على أعلى المعايير الأخلاقية والمهنية.",
    participation: "المشاركة المجتمعية والشمولية",
    participationDesc: "تمكين المجتمعات للمشاركة في القرارات التي تؤثر على حياتهم.",
    
    // Objectives
    strategicObjectives: "الأهداف الاستراتيجية",
    objectivesIntro: "تعمل منظمة مندولا على تحقيق رسالتها من خلال الأهداف الاستراتيجية التالية:",
    objective1: "تقديم المساعدة الإنسانية في الوقت المناسب للسكان المتضررين من الأزمات في جميع أنحاء السودان.",
    objective2: "تحسين الوصول للخدمات الأساسية بما في ذلك الصحة والمياه والصرف الصحي والنظافة.",
    objective3: "تعزيز المرونة والتعافي بين النازحين والمجتمعات الضعيفة.",
    objective4: "تعزيز الوعي بالصحة العامة والوقاية من الأمراض.",
    objective5: "دعم التنمية المجتمعية وبناء القدرات المحلية.",
    
    // Coverage
    geographicCoverage: "التغطية الجغرافية",
    coverageIntro: "تعمل منظمة مندولا على المستوى الوطني وتنفذ برامج إنسانية وتنموية في مناطق متعددة من السودان بناءً على الاحتياجات الناشئة والأولويات الإنسانية.",
    currentOperations: "العمليات الحالية",
    coverageText: "تتمتع المنظمة بخبرة في العمل في عدة مناطق وتحتفظ بمرونة تشغيلية تسمح بالاستجابة السريعة للطوارئ والتوسع في مناطق أخرى عبر السودان عند الحاجة.",
    redSeaState: "ولاية البحر الأحمر",
    khartoumState: "ولاية الخرطوم",
    northDarfurState: "ولاية شمال دارفور",
    gedarefState: "ولاية القضارف",
    blueNileState: "ولاية النيل الأزرق",
    whiteNileState: "ولاية النيل الأبيض",
    sennarState: "ولاية سنار",
    nationalReach: "الوصول الوطني",
    nationalReachDesc: "تحتفظ منظمة مندولا بمرونة تشغيلية للاستجابة السريعة للطوارئ وتوسيع التدخلات في مناطق أخرى عبر السودان عند الحاجة.",
    activeStates: "الولايات النشطة",
    nationalCoverage: "التغطية الوطنية",
    
    // Programs
    programmaticAreas: "المجالات البرامجية",
    programsIntro: "تنفذ منظمة مندولا برامج في عدة قطاعات إنسانية وتنموية:",
    health: "الصحة",
    healthDesc: "دعم الوصول لخدمات الرعاية الصحية وتعزيز الأنظمة الصحية.",
    nutrition: "التغذية",
    nutritionDesc: "تحسين التغذية للفئات الضعيفة، خاصة النساء والأطفال.",
    protection: "الحماية",
    protectionDesc: "ضمان السلامة والكرامة والحماية للفئات الضعيفة.",
    education: "التعليم",
    educationDesc: "دعم الوصول للتعليم للأطفال والمجتمعات النازحة.",
    wash: "المياه والصرف الصحي والنظافة",
    washDesc: "توفير المياه الآمنة والبنية التحتية للصرف الصحي والتوعية بالنظافة.",
    emergencyRelief: "المساعدة الإغاثية الطارئة",
    emergencyReliefDesc: "تقديم الدعم المنقذ للحياة أثناء الطوارئ والأزمات.",
    foodSecurity: "الأمن الغذائي ودعم سبل العيش",
    foodSecurityDesc: "مساعدة المجتمعات على تحسين الوصول للغذاء والدخل المستدام.",
    communityDevelopment: "التنمية المجتمعية",
    communityDevelopmentDesc: "دعم مبادرات المرونة والتنمية المجتمعية طويلة المدى.",
    operationalApproach: "النهج التشغيلي",
    approachText: "تتبنى منظمة مندولا نهجاً متمركزاً حول المجتمع وتشاركياً في تصميم وتنفيذ برامجها. تستند التدخلات إلى التقييمات الميدانية وتُنفذ بالتنسيق الوثيق مع المجتمعات المحلية والسلطات الحكومية والشركاء الإنسانيين.",
    communityEngagement: "المشاركة المجتمعية",
    communityEngagementDesc: "العمل الوثيق مع قادة المجتمع والمجموعات المحلية",
    mealSystems: "أنظمة المتابعة والتقييم",
    mealSystemsDesc: "دمج المتابعة والتقييم والمساءلة والتعلم",
    qualityDelivery: "التسليم عالي الجودة",
    qualityDeliveryDesc: "ضمان الشفافية والمساءلة والتحسين المستمر",
    
    // Projects
    projectsFieldExperience: "المشاريع والخبرة الميدانية",
    projectsIntro: "تسليط الضوء على تدخلاتنا الإنسانية الأخيرة وتأثيرها على المجتمعات",
    washProject: "دعم المياه والصرف الصحي لمركز إيواء النازحين أبو بكر الصديق",
    washLocation: "ولاية البحر الأحمر، السودان",
    washTarget: "مركز إيواء النازحين أبو بكر الصديق",
    washDescription: "نفذت منظمة مندولا مشروع المياه والصرف الصحي والنظافة لتحسين الظروف الصحية وتعزيز الصحة العامة بين النازحين داخلياً المقيمين في مركز الإيواء.",
    keyActivities: "الأنشطة الرئيسية",
    washActivity1: "توفير مياه الشرب الآمنة للمقيمين",
    washActivity2: "توزيع مواد النظافة والتنظيف",
    washActivity3: "حملات الصرف الصحي البيئي حول مركز الإيواء",
    washActivity4: "تفريغ وتنظيف المراحيض في المرفق الصحي للمأوى",
    washActivity5: "جلسات التوعية بالنظافة والصحة للعائلات النازحة",
    impact: "التأثير",
    washImpact: "ساعد المشروع في تحسين الظروف الصحية وتقليل المخاطر الصحية وزيادة الوعي بالنظافة بين المجتمعات النازحة.",
    emergencyWaterProject: "الاستجابة الطارئة للمياه - طويله، شمال دارفور",
    emergencyLocation: "منطقة طويله، ولاية شمال دارفور",
    emergencyTarget: "معسكر النازحين دبا نايرا",
    emergencyDescription: "نفذت منظمة مندولا تدخلاً إنسانياً طارئاً لتوفير مياه الشرب الآمنة للسكان النازحين داخلياً المقيمين في معسكر دبا نايرا.",
    emergencyActivity1: "توفير المياه الطارئة لمعسكر النازحين",
    emergencyActivity2: "صيانة وإصلاح نظام المياه",
    emergencyActivity3: "تعبئة المجتمع لإدارة المياه",
    emergencyActivity4: "جلسات التثقيف الصحي والنظافة",
    emergencyImpact: "عالج التدخل نقص المياه العاجل وساعد في تحسين ظروف المعيشة من خلال ضمان الوصول لمياه الشرب الآمنة وتقليل المخاطر الصحية المرتبطة بالمياه.",
    eidJoyProject: "مبادرة فرحة العيد",
    eidJoyLocation: "الخرطوم، ولاية الخرطوم",
    eidJoyTarget: "الأطفال والعائلات النازحة",
    eidJoyDescription: "نظمت منظمة مندولا مبادرة احتفالية خاصة بالعيد لإدخال الفرحة والدعم للأطفال والعائلات النازحة خلال عيد الفطر، من خلال توفير المواد الأساسية وخلق لحظات من السعادة في الأوقات الصعبة.",
    eidJoyActivity1: "توزيع هدايا العيد والملابس للأطفال النازحين",
    eidJoyActivity2: "توفير الطرود الغذائية والمواد الأساسية للعائلات",
    eidJoyActivity3: "تنظيم الأنشطة الترفيهية والاحتفالات",
    eidJoyActivity4: "أنشطة التجمع المجتمعي والدعم الاجتماعي",
    eidJoyImpact: "أدخلت المبادرة الفرحة للأطفال والعائلات النازحة، وعززت الروابط المجتمعية، ووفرت الدعم الأساسي خلال احتفالات العيد، مما ساعد على استعادة الشعور بالحياة الطبيعية والكرامة.",
    govInvolvement: "التعاون الحكومي",
    partnershipsCollaboration: "الشراكات والتعاون المؤسسي",
    partnershipsText: "تتعاون منظمة مندولا مع المنظمات الإنسانية ومؤسسات المجتمع المدني والسلطات الحكومية لضمان التنسيق الفعال وتقديم الخدمات.",
    governmentPartners: "الشركاء الحكوميون",
    federalMinistryHealth: "وزارة الصحة الاتحادية - السودان",
    stateMinistryHealthPort: "وزارة الصحة الولائية - بورتسودان (ولاية البحر الأحمر)",
    stateMinistryHealthKhartoum: "وزارة الصحة الولائية - ولاية الخرطوم",
    stateMinistryHealthDarfur: "وزارة الصحة الولائية - ولاية شمال دارفور",
    collaborationFocus: "محور التعاون",
    facilitateOperations: "تسهيل العمليات الإنسانية",
    supportHealthPrograms: "دعم برامج الصحة العامة",
    strengthenResponse: "تعزيز تنسيق الاستجابة للطوارئ",
    enhanceParticipation: "تعزيز المشاركة المجتمعية",
    targetArea: "المنطقة المستهدفة",
    
    // Partners
    partnersTitle: "شركاؤنا",
    partnersIntro: "تتعاون منظمة مندولا مع المنظمات الإنسانية ومؤسسات المجتمع المدني والسلطات الحكومية لضمان التنسيق الفعال وتقديم الخدمات.",
    internationalPartners: "الشركاء الدوليون",
    nationalPartners: "الشركاء الوطنيون",
    
    // Target Groups
    targetGroupsTitle: "الفئات المستهدفة",
    targetGroupsIntro: "تركز منظمة مندولا على دعم الفئات الأكثر ضعفاً في جميع أنحاء السودان",
    vulnerableYouth: "الشباب الضعفاء من الذكور والإناث",
    vulnerableWomen: "النساء والرجال الضعفاء",
    vulnerableChildren: "الأطفال الضعفاء",
    personsWithDisabilities: "الأشخاص ذوو الإعاقة",
    targetGroupsNote: "تشمل هذه الفئات النازحين داخلياً واللاجئين والعائدين والمجتمعات المضيفة.",
    
    // Organizational Structure
    orgStructureTitle: "الهيكل التنظيمي",
    boardOfDirectors: "مجلس الإدارة",
    executiveDirector: "المدير التنفيذي",
    programCoordinator: "منسق البرامج",
    adminFinanceHR: "الإدارة والمالية والموارد البشرية",
    programOfficer: "مسؤول البرامج",
    mealOfficer: "مسؤول المتابعة والتقييم",
    fieldCoordinator: "منسق ميداني",
    
    // Team
    teamTitle: "فريقنا",
    teamIntro: "تعرف على المحترفين المتفانين الذين يقودون الجهود الإنسانية لمنظمة مندولا",
    executiveDirectorName: "المدير التنفيذي",
    programAdvisor: "مستشار البرامج",
    publicRelations: "العلاقات العامة",
    
    // Donation
    donationTitle: "ادعم مهمتنا",
    donationIntro: "تساعدنا تبرعاتك على مواصلة عملنا في تقديم المساعدة الإنسانية ودعم المجتمعات الضعيفة وبناء مستقبل أفضل للسودان.",
    donateUSD: "التبرع بالدولار الأمريكي",
    donateSDG: "التبرع بالجنيه السوداني",
    usdDonationDesc: "التبرعات الدولية عبر التحويل البنكي",
    sdgDonationDesc: "التبرعات المحلية بالجنيه السوداني",
    bankName: "اسم البنك",
    accountName: "اسم الحساب",
    accountNumber: "رقم الحساب",
    swiftCode: "رمز السويفت",
    branch: "الفرع",
    contactForTransfer: "اتصل للحصول على تفاصيل التحويل",
    mashreqBank: "بنك النيل المشرق",
    mandolaOrg: "منظمة المندولة",
    khartoumBank: "بنك الخرطوم",
    altayebSiddiq: "الطيب صديق",
    bankAccount2450180: "2450180",
    
    // Contact
    contactTitle: "اتصل بنا",
    contactIntro: "تواصل مع منظمة مندولا لمعرفة المزيد عن عملنا أو استكشاف فرص الشراكة",
    
    // Get Involved
    getInvolvedTitle: "شارك معنا",
    getInvolvedSubtitle: "ادعم مهمتنا من خلال التبرعات أو التطوع أو الشراكات",
    
    // Media Center
    mediaCenterTitle: "المركز الإعلامي",
    mediaCenterSubtitle: "استكشف مشاريعنا وعملنا الإنساني من خلال الصور والفيديوهات",
    organization: "المنظمة",
    organizationName: "منظمة مندولا للإغاثة والإعمار",
    organizationType: "منظمة إنسانية وتنموية - السودان",
    address: "العنوان",
    sudan: "السودان",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    website: "الموقع الإلكتروني",
    ourCommitment: "التزامنا",
    commitmentP1: "تبقى منظمة مندولا ملتزمة بتقديم برامج إنسانية وتنموية عالية الجودة تعالج بفعالية احتياجات المجتمعات الضعيفة في جميع أنحاء السودان.",
    commitmentP2: "من خلال الشراكات القوية مع المؤسسات الحكومية والوكالات الإنسانية والمنظمات المجتمعية، تهدف منظمة مندولا إلى توسيع تأثيرها والمساهمة في التعافي والتنمية المستدامة في جميع أنحاء البلاد.",
    strongPartnerships: "شراكات قوية",
    effectivePrograms: "برامج فعالة",
    sustainableImpact: "تأثير مستدام",
    
    // Footer
    footerDescription: "دعم المجتمعات الضعيفة في جميع أنحاء السودان من خلال المساعدة الإنسانية وبرامج التعافي والتنمية المستدامة.",
    quickLinks: "روابط سريعة",
    aboutUs: "من نحن",
    ourValues: "قيمنا",
    contactInfo: "معلومات الاتصال",
    copyright: "2026 منظمة المندولة للإغاثة والإعمار. جميع الحقوق محفوظة.",
    backToTop: "العودة للأعلى",
    language: "اللغة",
    english: "English",
    arabic: "العربية"
  }
};